import { render, staticRenderFns } from "./MainLedgerCard1.vue?vue&type=template&id=0f19b89f&scoped=true"
import script from "./MainLedgerCard1.vue?vue&type=script&lang=js"
export * from "./MainLedgerCard1.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerCard1.vue?vue&type=style&index=0&id=0f19b89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19b89f",
  null
  
)

export default component.exports